import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  Chip,
  Button,
  Alert,
} from "@mui/material";
import api, { API_BASE_URL } from "../../utils/api";

const ArchitecturalRequestByMember = ({ propertyId }) => {
  console.log("📌 ArchitecturalRequestByMember Component Loaded");
  console.log("📌 Received propertyId as Prop:", propertyId);

  const [requests, setRequests] = useState([]);
  const [requestTypes, setRequestTypes] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [errorMessage, setErrorMessage] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    if (!propertyId || typeof propertyId !== "string" || propertyId.trim() === "") {
      console.warn("⚠️ No valid propertyId received. Skipping API call.");
      return;
    }

    const trimmedPropertyId = propertyId.trim();
    console.log("🔍 Fetching requests for propertyId:", trimmedPropertyId);

    fetchRequestsByMember(trimmedPropertyId);
    fetchRequestTypes();
  }, [propertyId]);

  const fetchRequestsByMember = async (trimmedPropertyId) => {
    try {
      const response = await api.get(`/architectural-requests/member/${trimmedPropertyId}`);

      

      if (Array.isArray(response.data)) {
       
        setRequests([...response.data]);
        setErrorMessage(null);
      } else {
        console.error("⚠️ Unexpected API response format:", response.data);
        setRequests([]);
        setErrorMessage("Invalid data format received.");
      }
    } catch (error) {
      console.error("❌ API Fetch Error:", error);
      setErrorMessage("Failed to load requests.");
      setRequests([]);
    }
  };

  const fetchRequestTypes = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/architectural-request-types`);
      const typeMap = {};
      response.data.forEach((type) => {
        typeMap[type.id] = type.type;
      });
      setRequestTypes(typeMap);
    } catch (error) {
      console.error("❌ Failed to fetch request types", error);
    }
  };

  const paginatedRequests = requests.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <Box sx={{ padding: 3 }}>
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}

      {requests.length > 0 ? (
        paginatedRequests.map((request) => (
          <Card
            key={request.id}
            sx={{
              borderRadius: 2,
              boxShadow: 2,
              borderLeft: `6px solid ${
                request.status.toLowerCase() === "pending"
                  ? "#ffc107"
                  : request.status.toLowerCase() === "approved"
                  ? "#4caf50"
                  : "#f44336"
              }`,
              padding: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                REQ-{request.id}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: "bold", color: "text.secondary" }}>
                {requestTypes[request.request_type] || `Type ID: ${request.request_type}`}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {new Date(request.requested_at).toLocaleDateString()}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Chip
                label={request.status.toUpperCase()}
                sx={{
                  backgroundColor:
                    request.status.toLowerCase() === "pending"
                      ? "#ffc107"
                      : request.status.toLowerCase() === "approved"
                      ? "#4caf50"
                      : "#f44336",
                  color: "#fff",
                  fontWeight: "bold",
                  paddingX: 1.5,
                }}
              />
              <Button
                component={Link}
                to={`/home/architecturalrequest/${request.id}`}
                variant="outlined"
                size="small"
              >
                View Details
              </Button>
            </Box>
          </Card>
        ))
      ) : (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          No requests found.
        </Typography>
      )}
    </Box>
  );
};

export default ArchitecturalRequestByMember;
